<script setup lang="ts">
interface Industry {
  name: string;
  icon: string;
  href: string;
}

const industries: Industry[] = [
  {
    name: "Construction",
    icon: "lucide:hard-hat",
    href: "/industry-security-solutions/jobsite-surveillance-system",
  },
  {
    name: "Retail",
    icon: "lucide:shopping-bag",
    href: "/industry-security-solutions/retail-security",
  },
  {
    name: "Healthcare & Aged Care",
    icon: "lucide:heart-pulse",
    href: "/industry-security-solutions/childcare-education",
  },
  {
    name: "Logistics & Warehousing",
    icon: "lucide:warehouse",
    href: "/industry-security-solutions/warehouse-security",
  },
  {
    name: "Professional Services",
    icon: "lucide:briefcase",
    href: "/industry-security-solutions",
  },
  {
    name: "Gyms & Fitness",
    icon: "lucide:dumbbell",
    href: "/industry-security-solutions/gym-fitness",
  },
  {
    name: "Property Management",
    icon: "lucide:building-2",
    href: "/industry-security-solutions/property-management",
  },
];
</script>

<template>
  <section class="bg-white py-16 lg:py-20">
    <div class="mx-auto max-w-7xl px-8">
      <!-- Section header -->
      <div class="text-center">
        <p class="text-sm font-semibold uppercase tracking-wider text-primary-400">
          Industries We Serve
        </p>
        <h2
          class="mt-2 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl"
        >
          Who we work with
        </h2>
        <p class="mx-auto mt-4 max-w-2xl text-lg leading-7 text-neutral-600">
          We specialise in multi-site SMEs and growing organisations that need dependable
          security, connectivity and IT.
        </p>
      </div>

      <!-- Industry pills (CTA style) -->
      <div class="mt-10 flex flex-wrap justify-center gap-3">
        <NuxtLink
          v-for="industry in industries"
          :key="industry.name"
          :to="industry.href"
          class="group inline-flex items-center gap-2 rounded-full border border-primary-400 px-5 py-2.5 font-bold text-primary-400 transition-all duration-300 hover:bg-primary-400 hover:text-white"
        >
          <Icon
            :name="industry.icon"
            size="20"
            class="transition-transform duration-300 group-hover:scale-110"
          />
          {{ industry.name }}
          <Icon
            name="lucide:arrow-right"
            size="16"
            class="opacity-0 transition-all duration-300 group-hover:translate-x-0.5 group-hover:opacity-100"
          />
        </NuxtLink>
      </div>
    </div>
  </section>
</template>
